import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus, FileEdit, Clock, CheckCircle2, Undo2 } from "lucide-react";

const STATS = [
  ["draft", "Drafts", FileEdit, "text-slate-700 bg-slate-100"],
  ["submitted", "Waiting", Clock, "text-amber-800 bg-amber-100"],
  ["approved", "Approved", CheckCircle2, "text-emerald-800 bg-emerald-100"],
  ["rejected", "Sent back", Undo2, "text-rose-800 bg-rose-100"],
];

export function RosterHomeHeader({ onCreate }) {
  const { actingOrgId } = useAuth();
  const { data = [] } = useQuery({ queryKey: ["roster-visible", actingOrgId], queryFn: async () => (await api.get("/roster/plans/visible")).data, staleTime: 0, refetchOnMount: "always" });
  const now = new Date();
  const thisMonth = data.filter((p) => p.year === now.getFullYear() && p.month === now.getMonth() + 1).length;
  return (
    <div className="mb-5 space-y-4" data-testid="roster-home">
      <Card className="flex flex-wrap items-center justify-between gap-4 p-6">
        <div>
          <p className="text-xl font-bold text-slate-900">All rosters</p>
          <p className="text-sm text-slate-600">{data.length} roster(s) in total, {thisMonth} for this month. Open any roster below, or create a new one.</p>
        </div>
        <Button size="lg" className="h-11" onClick={onCreate} data-testid="create-roster-btn"><Plus className="mr-1 h-5 w-5" /> Create roster</Button>
      </Card>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        {STATS.map(([k, label, Icon, cls]) => (
          <Card key={k} className="flex items-center gap-3 p-4" data-testid={`roster-stat-${k}`}>
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${cls}`}><Icon className="h-5 w-5" /></span>
            <div className="min-w-0">
              <p className="text-2xl font-bold text-slate-900">{data.filter((p) => (p.status || "draft") === k).length}</p>
              <p className="text-sm leading-tight text-slate-600">{label}</p>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
